import { createSlice } from "@reduxjs/toolkit";
import { CreateAppData } from "../types/CreateAppType";
import { getEnrichApiTokenAction } from "../action/getEnrichApiTokenAction";

const initialState: CreateAppData = {
  data: {},
  loading: false,
  error: null,
};

const getEnrichApiTokenSlice = createSlice({
  name: "getEnrichApiTokenSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getEnrichApiTokenAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getEnrichApiTokenAction.fulfilled, (state, action) => {
        // console.log("action payload EnrichApiToken---> ", action);
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getEnrichApiTokenAction.rejected, (state, action) => {
        state.loading = false;
        //state.error = action.payload;
      });
  },
});

export const getEnrichApiTokenReducer = getEnrichApiTokenSlice.reducer;
